import classNames from 'classnames';
import type { ReactElement } from 'react';
import React from 'react';
import type AddressType from 'types/address';
import getGoogleMapsLink from 'utils/get-google-maps-link';
import { validateString } from 'utils/validate-string';

import styles from './address.module.scss';

interface Props extends AddressType {
  readonly businessName?: string | undefined;
  readonly className?: string | undefined;
  readonly directions?: boolean | undefined;
}

const rootClass = validateString(styles.root);

export default function Address({
  businessName,
  className,
  city,
  directions = true,
  line1,
  line2,
  state,
  zipCode,
}: Readonly<Props>): ReactElement {
  if (directions) {
    return (
      <a
        className={classNames(rootClass, className)}
        href={getGoogleMapsLink({
          businessName,
          city,
          line1,
          line2,
          state,
          zipCode,
        })}
        target="_blank"
      >
        <span>
          {line1}, {line2}
        </span>
        <span>
          {city}, {state} {zipCode}
        </span>
      </a>
    );
  }
  return (
    <div className={classNames(rootClass, className)}>
      <span>
        {line1}, {line2}
      </span>
      <span>
        {city}, {state} {zipCode}
      </span>
    </div>
  );
}
